import { getSelectedRegionsForMultiSelect } from '@/common/helpers/helpers'

export const resolveRegionValues = (values, regions) => {
  if (!values?.length) return []
  if (typeof values[0] === 'object') return values

  return getSelectedRegionsForMultiSelect(values, regions)
}
